import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export function TermsConditions() {
  const { t } = useTranslation('kitComponents');
  const { merchantName} = useSelector(
    (state: any) => state.intention
  );
  const { termsUrl} = useSelector((state: any) => state.paymentDetails);

  return (
    <div className="my-4">
      <p className="text-sm font-medium leading-6 track-[0.01rem] text-gray-700">
        {t('CONFIRMING_TERMS')} {' '} {merchantName}{('\'s')} {' '}
        <a href={termsUrl} target="_blank" className="text-blue-500">
          {t('TERMS')}
        </a>
      </p>
    </div>
  );
}
